import {C1, getImageUrl} from '../../../utils/images';
import React, {Component} from 'react';
import ThreePack from '../../components/three-pack';

export function getListingImages(listings = []) {
    const images = [];
    const ids = Object.keys(listings);
    for (let index = 0; index < ids.length; index++) {
        const listing = listings[ids[index]];
        if (images.length === 3) {
            break;
        }
        if (listing && listing.galleryUrl) {
            let image = getImageUrl(listing.galleryUrl, C1);
            images.push(image);
        }
    }
    return {
        image1: images[0],
        image2: images[1],
        image3: images[2]
    };
}

export class ModalCard extends Component {
    static defaultProps = {
        listings: []
    }

    constructor(props) {
        super(props);
        this.state = {
            image1: null,
            image2: null,
            image3: null
        };
    }

    componentDidMount() {
        this.getPreviewImages();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {image1} = nextState;
        const {state} = this;
        return image1 !== state.image1;
    }

    getPreviewImages = () => {
        const {listings} = this.props;
        const imageProps = getListingImages(listings);
        this.setState({...imageProps});
    }

    render() {
        const {image1, image2, image3} = this.state;
        const {name} = this.props;
        return (
            <div className="card collab-modal__card">
                <h6 className="collab-modal__card-name">{name}</h6>
                <ThreePack
                    image1={image1}
                    image2={image2}
                    image3={image3}
                />
            </div>
        );
    }
}

export default ModalCard;


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/preview-card.js